/**
 * Global Suryavansh quick-add + product helpers
 */
(function () {
  if (window.__svQuickAddBound) return;
  window.__svQuickAddBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-sv-quick-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (section) { return section.id; }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';

    fetch(addUrl, config)
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (response.status && response.status >= 400) throw response;
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (cart.classList) cart.classList.remove('is-empty');
          if (typeof cart.open === 'function') cart.open();
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        window.location.href = '/cart';
      })
      .finally(function () {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('is-loading');
      });
  });
})();
